import { api } from "./api";

export interface PatrulhaResponsavel {
  id: string;
  id_patrulha: string;
  id_militar: string;
  militar: {
    id: string;
    nick: string;
    patente: {
      id: string;
      patente: string;
      abreviacao: string;
    };
  };
  funcao: string;
  data_hora_inicio: string;
  data_hora_pausa?: string | null;
  data_hora_termino?: string | null;
  tempo_pausado_segundos: number;
  status: string;
  criado_em: string;
  alterado_em: string;
}

export interface AssumirFuncaoDTO {
  funcao: string;
}

export interface PassarFuncaoDTO {
  id_militar_novo: string;
}

export const patrulhasResponsaveisService = {
  async listarAtivos(): Promise<PatrulhaResponsavel[]> {
    const response = await api.get("/patrulhas/responsaveis/ativos");
    return response.data;
  },

  async assumir(data: AssumirFuncaoDTO): Promise<PatrulhaResponsavel> {
    const response = await api.post("/patrulhas/responsaveis/assumir", data);
    return response.data;
  },

  async pegar(data: AssumirFuncaoDTO): Promise<PatrulhaResponsavel> {
    const response = await api.post("/patrulhas/responsaveis/pegar", data);
    return response.data;
  },

  async pausar(): Promise<PatrulhaResponsavel> {
    const response = await api.patch("/patrulhas/responsaveis/pausar");
    return response.data;
  },

  async retomar(): Promise<PatrulhaResponsavel> {
    const response = await api.patch("/patrulhas/responsaveis/retomar");
    return response.data;
  },

  async finalizar(): Promise<PatrulhaResponsavel> {
    const response = await api.patch("/patrulhas/responsaveis/finalizar");
    return response.data;
  },

  async passar(data: PassarFuncaoDTO): Promise<PatrulhaResponsavel> {
    const response = await api.post("/patrulhas/responsaveis/passar", data);
    return response.data;
  },
};
